/* Scrolling shared across the site. The home page creates a smooth-scroll
   controller (Lenis) and registers it here; anything that scrolls to a section
   goes through scrollToId so it works with or without that controller. */

let scroller = null;

export const setScroller = (lenis) => {
  scroller = lenis;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (scroller) scroller.scrollTo(el);
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

// Scroll the page to a vertical position, smoothly
export const scrollToY = (y) => {
  if (scroller) scroller.scrollTo(y);
  else window.scrollTo({ top: y, behavior: "smooth" });
};
